/**
 * @member {Object} friendlyChallenge
 */

/**
 * @class FriendlyCaptcha
 * @module Ladies.Utility
 *
 * Stellt die Möglichkeit zur Einbindung eines FriendlyCaptcha
 *    innerhalb eines Formulars zur Verfügung
 *
 * @type {HCaptcha}
 * @requires jQuery
 *
 * @param {jQuery|Function} $
 */
import "../_vendor/js/friendly-captcha-widget.js"
window.Ladies.Utility.FriendlyCaptcha = (($) => {
    /**
     * Setzt das Form-Element, die Callback-Methode und die übergebene Sprache.
     *    Falls kein Sprach-Kürzel mit übergeben wurde wird das Standardkürzel
     *    gesetzt.
     *
     * @public
     * @constructor
     *
     * @param {HTMLFormElement|jQuery} form
     * @param {Function} confirmedCallback
     * @param {Function} expiredCallback
     * @param {string} [language]
     * @param {boolean} [renderImmediately]
     */
    function FriendlyCaptcha(form, confirmedCallback, expiredCallback, language, renderImmediately) {
        const init = this.init.bind(this)

        if (form instanceof $) {
            this.formElement = form
        } else {
            this.formElement = $(form)
        }

        this.captchaField = this.formElement.find(this.captchaFieldClass).get(0)
        this.language = language || this.language
        this.queued = this.queued
        this.captchaOptions = jQuery.extend({}, this.captchaOptions)
        this.renderImmediately = renderImmediately || this.renderImmediately

        this.captchaOptions.doneCallback = confirmedCallback
        this.captchaOptions.expiredCallback = expiredCallback

        init()
    }

    FriendlyCaptcha.prototype = {
        /**
         * @var {jQuery} jQuery-Objekt der Form-Referenz
         * @private
         */
        formElement: null,

        /**
         * @var {string} Klasse zum Auslesen des captcha-Feldes
         * @private
         */
        captchaFieldClass: ".friendly-captcha",

        /**
         * @var {Element} DOM-Referenz auf das captcha-Feld
         * @private
         */
        captchaField: null,

        /**
         * @var {string} Das Kürzel der aktuellen Sprache
         * @private
         */
        language: "de",

        /**
         * @var {boolean} Flag, ob das Rendern warten muss
         * @private
         */
        queued: false,

        /**
         * @var {Object} Optionen zum Laden des captcha
         * @private
         */
        captchaOptions: {
            language: "de",

            sitekey: "",
            tabindex: 0,

            callback: null,
            // ToDo: Möglich zu implementieren (Reload bei Klick?)
            "expired-callback": null,
            "error-callback": null,
        },

        /**
         * @var {number} ReferenzId auf das captcha der aktuellen Instanz
         * @private
         */
        captchaId: null,

        /**
         * @var {friendlyChallenge.WidgetInstance} Captcha-Instanz
         * @private
         */
        captchaInstance: null,

        /**
         * @var {boolean} Flag, ob direkt bei der Instanzerstellung auch
         *    gerendert werden soll
         * @private
         */
        renderImmediately: false,

        /**
         * Prüft, ob das captcha-Script geladen wurde. Falls dies nicht
         *    der Fall ist wird das laden angestoßen. Damit das Script nur einmal
         *    geladen wird, wird das globale hcaptcha-Property von undefined
         *    auf null gesetzt.
         *
         * Es wird außerdem das Flag 'queued' auf true und ein EventListener
         *    auf das window-Objekt gesetzt, über den nach erfolgreichem Laden
         *    des Scripts das eigentliche Rendern aller Captchas, die queue auf
         *    true haben, über einen Trigger angestoßen wird.
         *
         * @private
         */
        init: function () {
            this.captchaOptions.language = this.language
            this.captchaOptions.sitekey = "FCMGFRDHPJCAQL21"

            this.captchaInstance = new friendlyChallenge.WidgetInstance(this.captchaField, this.captchaOptions)
            this.formElement.trigger("ready.render:reCaptcha")
        },

        execute: () => {
            //
        },

        render: function () {
            if (this.captchaInstance && "reset" in this.captchaInstance) {
                this.captchaInstance.reset()
            }
        },
    }

    // Es müssen bei der Verwendung Instanzen erzeugt werden
    return FriendlyCaptcha
})(jQuery)
